"use client";

import { useQuery } from "@tanstack/react-query";
import { browserCoreApi } from "@/lib/api";
import { songKeys } from "./query-keys";

export function useSong(id: number | string) {
  return useQuery({
    queryKey: songKeys.detail(id),
    queryFn: ({ signal }) => browserCoreApi.songs.detail(id, signal),
  });
}

export function useSongRelated(id: number | string) {
  return useQuery({
    queryKey: songKeys.related(id),
    queryFn: ({ signal }) => browserCoreApi.songs.related(id, signal),
  });
}
